import {ProductQuantityDiscount} from 'views/webshop/pages'

export const toCents = (price: string) => {
	if (!price) return 0
	return parseFloat(price.replace(',', '.')) * 100
}

export const toVisualPrice = (price: number) => {
	if (!price) return 0
	const priceDecimal = price / 100
	return priceDecimal.toFixed(2).toString().replace('.', ',')
}

export const getPriceDiscount = (
	discounts: Array<ProductQuantityDiscount>,
	quantity: number
) => {
	if (!discounts?.length || !discounts[0].quantity) return null

	return discounts.find((discount, i) => {
		const nextDiscount = discounts[i + 1]
		// quantity is smaller then
		if (quantity < Number(discount.quantity)) return false
		// no bigger discount
		if (!nextDiscount) return true
		// current discount, smaller than next, bigger than current
		if (
			quantity >= Number(discount.quantity) &&
			quantity < Number(nextDiscount.quantity)
		)
			return true
	})
}

export const number_format = (
	number: number,
	decimals: number = 0,
	decimal_separator: string = '.',
	thousands_separator: string = ','
): string => {
	const numberWithoutDecimals: number = Math.floor(number)
	let formatted: string = `${numberWithoutDecimals
		.toString()
		.replace(/\B(?=(\d{3})+(?!\d))/g, thousands_separator)}`
	if (decimals > 0) {
		formatted += decimal_separator
		let decimalValue: string = `${
			(number - numberWithoutDecimals) * Math.pow(10, decimals)
		}`.substr(0, decimals)
		while (decimalValue.length < decimals) {
			decimalValue += '0'
		}
		formatted += decimalValue
	}
	return formatted
}
